import axios from "axios";
import { MetalPurityCaratType } from "./metal_purity_karat.types";
import { environment } from "../../environments/environment";

const API_BASE_NAME = `${environment.apiBaseUrl}`;

const authHeader = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});


// ✅ CREATE
export const createMetalPurityCarat = async (
  payload: MetalPurityCaratType
): Promise<any> => {
  try {
    const response = await axios.post(
      `${API_BASE_NAME}/metal-purity-carat/create`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          ...authHeader().headers,
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error(
      "Error creating metal purity carat:",
      error.response?.data || error.message
    );
    throw error;
  }
};


// ✅ GET ALL (optional filter)
export const getAllMetalPurityCarat = async (
  metalTypeId?: number
): Promise<{ success: boolean; data: MetalPurityCaratType[] }> => {
  try {
    const response = await axios.get(
      `${API_BASE_NAME}/metal-purity-carat/getAll`,
      {
        params: metalTypeId ? { metalTypeId } : {},
        ...authHeader(),
      }
    );

    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching metal purity carat:",
      error.response?.data || error.message
    );
    throw error;
  }
};


// ✅ UPDATE
export const updateMetalPurityCarat = async (
  id: number,
  payload: Partial<MetalPurityCaratType>
): Promise<any> => {
  try {
    const response = await axios.put(
      `${API_BASE_NAME}/metal-purity-carat/update/${id}`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          ...authHeader().headers,
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error(
      "Error updating metal purity carat:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// ✅ DELETE
export const deleteMetalPurityCarat = async (id: number): Promise<any> => {
  try {
    const response = await axios.delete(
      `${API_BASE_NAME}/metal-purity-carat/delete/${id}`,
      authHeader()
    );
    return response.data;
  } catch (error: any) {
    console.error(
      "Error deleting metal purity carat:",
      error.response?.data || error.message
    );
    throw error;
  }
};
